import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton.tsx';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {RetireRecordButton} from '../buttons/RetireRecordButton.tsx';
import config from '../config';

const useTools = () => {

    const {allowedActions} = useVerifiedPermissions();

    // No Add, no Edit, and — importantly — no Delete: there is no
    // deleteSyntheticUser mutation on the API. FNP-969 adds RETIRE, which
    // tombstones the row rather than removing it.
    const tools = [
        <FilterRecordsButton key='filter'/>,
        <ReloadRecordsButton key='reload'/>,
    ];

    if (allowedActions.includes(rbacActions.RetireSyntheticUser)) {
        tools.push(<RetireRecordButton key='retire'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
